import { Component, Input, OnInit } from '@angular/core';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import { SubProjectDisplay } from '../most-recent-placement-helper';

@Component({
  selector: 'most-recent-placement-item',
  templateUrl: './most-recent-placement-item.component.html',
  styleUrls: ['./most-recent-placement-item.component.scss']
})
export class MostRecentPlacementItemComponent implements OnInit {
  @Input()
  subProjectDisplay: SubProjectDisplay;

  SUB_PROJECT_TYPES = SUB_PROJECT_TYPES;

  backgroundImageStyle: any;

  constructor(private _lightbox: Lightbox) {}

  ngOnInit(): void {
    if (this.subProjectDisplay.type === SUB_PROJECT_TYPES.BASE_PROJECT) {
      this.setBaseProjectBackgroundImage();
    } else {
      this.setAdjustmentBackgroundImage();
    }
  }

  private setBaseProjectBackgroundImage(): void {
    if (
      CollectionHelper.isPopulated(this.subProjectDisplay.products) &&
      this.subProjectDisplay.products[0].firstAsset != null
    ) {
      this.backgroundImageStyle = this.getBackgroundImageStyle(
        `/api/assets/${this.subProjectDisplay.products[0].firstAsset.asset.uuid}/330/225`
      );
    }
  }

  private setAdjustmentBackgroundImage(): void {
    if (this.subProjectDisplay.firstAsset != null) {
      this.backgroundImageStyle = this.getBackgroundImageStyle(
        `/api/assets/${this.subProjectDisplay.firstAsset.asset.uuid}/330/225`
      );
    }
  }

  private getBackgroundImageStyle(url: string): any {
    return {
      'background-image': `url('${url}')`,
      'background-position': 'center',
      'background-repeat': 'no-repeat'
    };
  }

  openAlbum(album: IAlbum[]): void {
    this._lightbox.open(album);
  }
}
